<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-notification-host />
</ion-app>
